<template>
	<div class="p-20">
		<el-row>
			<el-col :span="24">
				<div>
					<div>
						<h1>Welcome</h1>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {};
	}
};
</script>
